import { render, staticRenderFns } from "./shopList.vue?vue&type=template&id=66f1f5dc&"
import script from "./shopList.vue?vue&type=script&lang=js&"
export * from "./shopList.vue?vue&type=script&lang=js&"
import style0 from "./shopList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports